export const BackgroundWaveLine3Flipped = ({
  className = ""
}: {
  className?: string;
}) => {
  return (
    <div className={className}>
      <svg
        width="100"
        height="100"
        viewBox="0 0 355 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="1"
          d="M1.00001 40.0614C66.4074 80.4646 104.354 61.2533 174.255 69.4252C255.14 78.8814 305.069 157.019 354 148.326C307.566 136.614 239.163 53.4991 239.163 53.4991C239.163 53.4991 180.246 -10.2054 142.799 2.7346C105.352 15.6746 25.4654 65.9414 1.00001 29.1122M1.00001 91.3236C68.9038 48.429 183.349 22.1446 212.7 22.1446C261.132 22.1446 317.552 132.623 354 136.614M1.00001 49.5176C80.8869 79.8767 158.575 135.873 194.226 107.425C279.605 39.2957 305.569 39.5873 354 67.0215"
          stroke="url(#paint0_linear_562_4558)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_562_4558"
            x1="354"
            y1="95.3053"
            x2="0.500709"
            y2="95.3053"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="CurrentColor" />
            <stop offset="0.9" stopColor="CurrentColor" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
